import PropTypes from "prop-types";
import RHFTextField from "../../components/hook-form/RHFTextField";

const CustomQuantityInput = ({ value, onChange, error, sx,disabled, decimalDigits }) => {
  const validateQuantity = (val) => {
    if (!val || val === "") return "Quantity is required";
    const num = parseFloat(val);
    if (isNaN(num)) return "Please enter a valid number";
    if (num <= 0) return "Quantity must be greater than 0";
    if (num > 9999999999) return "Quantity cannot exceed 9999999999";

    const decimalPart = val.split(".")[1];
    if (decimalPart && decimalPart.length > decimalDigits) return `Maximum ${decimalDigits} decimal places allowed`;

    return "";
  };

  const handleChange = (e) => {
    let val = e.target.value;
    val = val.replace(/[^0-9.]/g, "");
    const parts = val.split(".");
    if (parts.length > decimalDigits ) val = parts[0] + "." + parts.slice(1).join("");
    if (parts.length === decimalDigits && parts[1].length > decimalDigits) val = parts[0] + "." + parts[1].substring(0, decimalDigits);

    const validationError = validateQuantity(val);
    onChange(val, validationError);
  };

  return (
    <RHFTextField
      name="quantity"
      label="Custom Quantity"
      type="text"
      value={value}
      error={!!error}
      helperText={error}
      disabled={disabled}
      onKeyDown={(e) => {
        if (["e", "E", "+", "-"].includes(e.key) || (e.key === "." && value.includes("."))) {
          e.preventDefault();
        }
      }}
      onChange={handleChange}
      sx={{
        mt: 2,
        mx: 1,
        width: { xs: "100%", md: 450 },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: error ? "red" : "#fda92d",
          },
          "&:hover fieldset": {
            borderColor: error ? "red" : "#fda92d",
          },
          "&.Mui-focused fieldset": {
            borderColor: error ? "red" : "#fda92d",
          },
        },
        ...sx,
      }}
      InputProps={{ inputProps: { inputMode: "decimal" } }}
    />
  );
};

CustomQuantityInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  sx: PropTypes.object,
};

export default CustomQuantityInput;
